import { render } from "./CreateEditDeliveryView.vue?vue&type=template&id=121031c5&scoped=true&ts=true"
import script from "./CreateEditDeliveryView.vue?vue&type=script&lang=ts"
export * from "./CreateEditDeliveryView.vue?vue&type=script&lang=ts"

import "./CreateEditDeliveryView.vue?vue&type=style&index=0&id=121031c5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121031c5"]])

export default __exports__